import { Component, inject, OnInit } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { initFlowbite } from 'flowbite';
import { UserService } from './core/services/user.service';
import { NgxSpinnerModule } from 'ngx-spinner';
import { ModalComponent } from './shared/components/modal/modal.component';
import { TooltipContainerComponent } from './shared/components/tooltip-container/tooltip-container.component';
@Component({
  selector: 'app-root',
  standalone: true,
  imports: [RouterOutlet, NgxSpinnerModule, ModalComponent, TooltipContainerComponent],
  templateUrl: './app.component.html'
})
export class AppComponent implements OnInit {
  public title = 'dcarbonizer';
  public userService = inject(UserService);

  ngOnInit(): void {
    initFlowbite();
  }
}
